<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props:['chartData','options','height'],
  methods: {
    update() {
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
};
</script>
